import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { salesMasterHoldData, SalesMasterHold } from '../../../interfaces/masters/salesmasterhold';
import { SalesMasterHoldApi } from '../api/salesmasterhold.api';
@Injectable() 
export class SalesMasterHoldService extends salesMasterHoldData{
 
  constructor(private api: SalesMasterHoldApi) {
    super();
  } 
  
  getall(url: string): Observable<SalesMasterHold[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<SalesMasterHold>{
      return this.api.getby_id(url);
  }

  create(url: string, data:SalesMasterHold): Observable<SalesMasterHold[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:SalesMasterHold): Observable<SalesMasterHold> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }
}
